module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path d=\"M32 19l-6-6V4h-4v5l-6-6L0 19v1h4v10h10v-6h4v6h10V20h4z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/home.svg
// module id = vIvP
// module chunks = 1